import React, { useEffect } from 'react'
import axios from "axios";
import * as IMG from '../images'
import AboutPage from '../pages/MainRoute/AboutPage'
import BusinessPage from '../pages/MainRoute/BusinessPage/'
import TeamPage from '../pages/MainRoute/TeamPage/'
import PeriodicalPage from '../pages/MainRoute/PeriodicalPage/'
import NewsPage from '../pages/MainRoute/NewsPage/'
import ExternalPage from '../pages/MainRoute/ExternalPage/'
import ParkingPage from '../pages/MainRoute/ParkingPage';

export const DataContext = React.createContext()

export const DataProvider = ({ children }) => {
    const [navs, setNavs] = React.useState(_navs)
    const [menu_nav, setMenuNav] = React.useState(_menu_navs)
    const [about, setAbout] = React.useState(_about)
    const [businesses, setBusinesses] = React.useState(_businesses)
    const [teams, setTeams] = React.useState(_teams)
    const [periodicals, setPeriodicals] = React.useState(_periodicals)
    const [news, setNews] = React.useState(_news)
    const [footer, setFooter] = React.useState(_footer);
    const [externals, setExternals] = React.useState(_externals)

    const getAbout = () => {
        service({
            url: '/info/about',
            method: 'get'
        }).then((response) => {
            response.data.introduction.img = [IMG.landing_cover, IMG.tmp_banner];
            response.data.service = {
                label: response.data.service.label,
                detail: [
                    {
                        label: '專業團隊',
                        icon: IMG.first,
                        detail: response.data.service.detail[0],
                    },
                    {
                        label: '國際視野',
                        icon: IMG.second,
                        detail: response.data.service.detail[1],
                    },
                    {
                        label: '量身打造',
                        icon: IMG.third,
                        detail: response.data.service.detail[2],
                    },
                    {
                        label: '多元服務',
                        icon: IMG.four,
                        detail: response.data.service.detail[3],
                    },
                ],
            }
            setAbout(response.data);
        })
    }

    const getServices = () => {
        service({
            url: '/info/service',
            method: 'get'
        }).then((response) => {
            setBusinesses(response.data);
        })
    }

    const getNews = () => {
        service({
            url: '/info/news',
            method: 'get'
        }).then((response) => {
            setNews(response.data);
        })
    }

    const getPeriodical = () => {
        service({
            url: '/info/periodicals',
            method: 'get'
        }).then((response) => {
            setPeriodicals(response.data);
        })
    }

    const getLawyer = () => {
        service({
            url: '/info/lawyer',
            method: 'get'
        }).then((response) => {
            setTeams(response.data);
        })
    }

    const getFooter = () => {
        service({
            url: '/info/footer',
            method: 'get'
        }).then((response) => {
            console.log(response.data);
            setFooter(response.data);
        })
    }

    const getExternal = () => {
        service({
            url: '/info/external',
            method: 'get'
        }).then((response) => {
            console.log(response.data);
            setExternals(response.data);
        })
    }

    useEffect(() => {
        getAbout();
        getServices();
        getNews();
        getPeriodical();
        getLawyer();
        getFooter();
        getExternal();
    }, [])

    return (
        <DataContext.Provider
            value={{
                navs,
                setNavs,
                about,
                setAbout,
                businesses,
                setBusinesses,
                teams,
                setTeams,
                periodicals,
                setPeriodicals,
                news,
                setNews,
                externals,
                setExternals,
                footer,
                setFooter,
                menu_nav,
                setMenuNav
            }}
        >
            {children}
        </DataContext.Provider>
    )
}

const service = axios.create({
    baseURL: "https://manage.hawyeu.com.tw",
    timeout: 5000,
});

export const useNavs = () => [
    React.useContext(DataContext).navs,
    React.useContext(DataContext).setNavs,
]

export const useMenuNav = () => [
    React.useContext(DataContext).menu_nav,
    React.useContext(DataContext).setMenuNav,
]

export const useAbout = () => [
    React.useContext(DataContext).about,
    React.useContext(DataContext).setAbout,
]

export const useBusinesses = () => [
    React.useContext(DataContext).businesses,
    React.useContext(DataContext).setBusinesses,
]

export const useTeams = () => [
    React.useContext(DataContext).teams,
    React.useContext(DataContext).setTeams,
]

export const usePeriodicals = () => [
    React.useContext(DataContext).periodicals,
    React.useContext(DataContext).setPeriodicals,
]

export const useNews = () => [
    React.useContext(DataContext).news,
    React.useContext(DataContext).setNews,
]

export const useExternals = () => [
    React.useContext(DataContext).externals,
    React.useContext(DataContext).setExternals,
]

export const useFooter = () => [
    React.useContext(DataContext).footer,
    React.useContext(DataContext).setFooter,
]

// data
const _about = {
    introduction: {
        label: '本所簡介',
        detail: [
            '浩宇法律事務所由林凱律師及劉楷律師於１９９６年１１月在桃園市共同創設，２００６年擴大服務範圍，在台北市中正區設立台北所，且陸續有律師精英加入團隊。',
            '本所秉持誠信的理念，不斷深耕經營資深得服務團隊累積豐富的經驗，掌握國際脈動、社會結構得轉變與時俱進，結合豐厚的底蘊與創新的思維為客戶提供即時、優質的法律建議，是客戶值得倚賴的保障',
        ],
        img: [IMG.landing_cover, IMG.tmp_banner],
    },
    structure: {
        label: '事務所結構',
        detail: [
            ['１５＋', '成員數', '優質完善的法律團隊'],
            ['１９９６', '成立', '豐富、務實的多年經驗'],
            ['２', '事務所', '桃園所Ｘ台北所'],
        ],
    },
    service: {
        label: '完整服務',
        detail: [
            {
                label: '專業團隊',
                icon: IMG.temp2,
                detail:
                    '擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。',
            },
            {
                label: '國際視野',
                icon: IMG.temp2,
                detail:
                    '擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。',
            },
            {
                label: '量身打造',
                icon: IMG.temp2,
                detail:
                    '擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。',
            },
            {
                label: '多元服務',
                icon: IMG.temp2,
                detail:
                    '擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。',
            },
        ],
    },
}

const _businesses = [
    {
        id: '1',
        label: '常年法律顧問',
        path: '/business/1',
        detail: [
            '以電聯或來所諮詢方式，就法律意見為討論。',
            '以電聯或來所諮詢方式，就法律意見為討論。',
            '以電聯或來所諮詢方式，就法律意見為討論。',
            '以電聯或來所諮詢方式，就法律意見為討論。',
        ],
    },
    {
        id: '2',
        label: '一般訴訟與執行案件',
        path: '/business/2',
        detail: [
            '以一般訴訟與執行方式，就法律意見為討論。',
            '以一般訴訟與執行方式，就法律意見為討論。',
            '以一般訴訟與執行方式，就法律意見為討論。',
        ],
    },
    {
        id: '3',
        label: '智慧財產權案件',
        path: '/business/3',
        detail: [
            '以電聯或來所諮詢方式，就法律意見為討論。',
            '以電聯或來所諮詢方式，就法律意見為討論。',
            '以電聯或來所諮詢方式，就法律意見為討論。',
            '以電聯或來所諮詢方式，就法律意見為討論。',
        ],
    },
    {
        id: '4',
        label: '非訟案件',
        path: '/business/4',
        detail: [
            '以電聯或來所諮詢方式，就法律意見為討論。',
            '以電聯或來所諮詢方式，就法律意見為討論。',
            '以電聯或來所諮詢方式，就法律意見為討論。',
            '以電聯或來所諮詢方式，就法律意見為討論。',
        ],
    },
    {
        id: '5',
        label: '公司商務案件',
        path: '/business/5',
        detail: [
            '以電聯或來所諮詢方式，就法律意見為討論。',
            '以電聯或來所諮詢方式，就法律意見為討論。',
            '以電聯或來所諮詢方式，就法律意見為討論。',
            '以電聯或來所諮詢方式，就法律意見為討論。',
        ],
    },
    {
        id: '6',
        label: '不動產爭議',
        path: '/business/6',
        detail: [
            '以電聯或來所諮詢方式，就法律意見為討論。',
            '以電聯或來所諮詢方式，就法律意見為討論。',
            '以電聯或來所諮詢方式，就法律意見為討論。',
            '以電聯或來所諮詢方式，就法律意見為討論。',
        ],
    },
    {
        id: '7',
        label: '家事案件',
        path: '/business/7',
        detail: [
            '以電聯或來所諮詢方式，就法律意見為討論。',
            '以電聯或來所諮詢方式，就法律意見為討論。',
            '以電聯或來所諮詢方式，就法律意見為討論。',
            '以電聯或來所諮詢方式，就法律意見為討論。',
        ],
    },
    {
        id: '8',
        label: '政府採購爭議案件',
        path: '/business/8',
        detail: [
            '以電聯或來所諮詢方式，就法律意見為討論。',
            '以電聯或來所諮詢方式，就法律意見為討論。',
            '以電聯或來所諮詢方式，就法律意見為討論。',
            '以電聯或來所諮詢方式，就法律意見為討論。',
        ],
    },
    {
        id: '9',
        label: '遺產繼承案件',
        path: '/business/9',
        detail: [
            '以電聯或來所諮詢方式，就法律意見為討論。',
            '以電聯或來所諮詢方式，就法律意見為討論。',
            '以電聯或來所諮詢方式，就法律意見為討論。',
            '以電聯或來所諮詢方式，就法律意見為討論。',
        ],
    },
]

const _teams = [
]

const _periodicals = [
    {
        id: '1',
        label: '如何讓家族企業繼續傳承－閉鎖型公司的規劃',
        author: '林凱律師',
        date: '2020.10.21',
        detail:
            '擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。',
    },
    {
        id: '2',
        label: '試用期間	法規知多少？',
        author: '陳建寰律師',
        date: '2021.12.21',
        detail:
            '擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。',
    },
]

const _news = [
    {
        id: '1',
        label: '如何讓家族企業繼續傳承－閉鎖型公司的規劃',
        date: '2020.10.21',
        detail:
            '擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。',
    },
    {
        id: '2',
        label: '試用期間	法規知多少？',
        date: '2021.12.21',
        detail:
            '擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。擔任多家上市櫃公司、中小型企業、財團法人及政府機關之法律顧問。浩宇法律事務所注重細節，秉持誠信職業綜合能力卓越，於關鍵時刻上，給予重要有利的建議。',
    },
    {
        id: '3',
        label: '今天吃啥米東東？',
        date: '2021.09.21',
        detail: '浩宇法律事務所注重細節。',
    },
]

const _externals = [
    {
        id: '1',
        label: '裁判書查詢',
        path: '/about',
    },
    {
        id: '2',
        label: '司法院及所屬機關清單',
        path: '/team',
    },
    {
        id: '3',
        label: '全國法規資料庫',
        path: '/periodical',
    },
    {
        id: '4',
        label: '經濟部商工登記查詢',
        path: '/news',
    },
]

const _navs = [
    {
        id: '1',
        key: 'about',
        path: '/about',
        to: '/about',
        label: { tw: '關於浩宇', en: 'about' },
        component: AboutPage,
        bannerImg: IMG.banner_about,
        navs: [
            {
                id: '1',
                label: '本所簡介',
                path: '/about',
            },
        ],
    },
    {
        id: '2',
        key: 'business',
        path: '/business',
        to: '/business',
        label: { tw: '業務項目', en: 'business' },
        component: BusinessPage,
        bannerImg: IMG.banner_business,
        navs: _businesses,
    },
    {
        id: '3',
        key: 'team',
        path: '/team',
        to: '/team',
        label: { tw: '專業團隊', en: 'team' },
        component: TeamPage,
        bannerImg: IMG.banner_team,
        navs: _teams.map((v) => ({ ...v, label: `${v.label}律師` })),
    },
    {
        id: '4',
        key: 'periodical',
        path: '/periodical',
        to: '/periodical',
        label: { tw: '法律期刊', en: 'periodical' },
        component: PeriodicalPage,
        bannerImg: IMG.banner_periodical,
        navs: [
            {
                id: '1',
                label: '總覽',
                path: '/periodical',
            },
        ],
    },
    {
        id: '5',
        key: 'news',
        path: '/news',
        label: { tw: '最新消息', en: 'news' },
        component: NewsPage,
        bannerImg: IMG.banner_news,
        navs: [
        ],
    },
    {
        id: '6',
        key: 'external',
        path: '/external',
        label: { tw: '外部連結', en: 'external' },
        component: ExternalPage,
        bannerImg: IMG.banner_external,
        navs: [
            {
                id: '1',
                label: '各司法相關網站連結',
                path: '/external',
            },
        ],
    },
    {
        id: '7',
        key: 'parking',
        path: '/parking',
        label: { tw: '停車資訊', en: 'parking' },
        component: ParkingPage,
        bannerImg: IMG.banner_external,
        navs: [
            {
                id: '1',
                label: '停車資訊',
                path: '/parking',
            },
        ],
    },
]

const _footer = {
    title: "浩宇法律事務所｜週一至週五 09:00-17:30",
    taoyuan: {
        site: '桃園所｜',
        phone: '(03)337-3299',
        tax: '(03)332-6088',
        email: 'hawyeu@ms23.hinet.net',
        address: '桃園市桃園區中山路545號9樓'
    },
    taipei: {
        site: '台北所｜',
        phone: '(02)2370-6869',
        tax: '(02)2370-8658',
        email: 'hawyeu@ms23.hinet.net',
        address: '台北市中正區開封街1段66號2樓'
    }
}

const _menu_navs = [
    {
        id: '1',
        key: 'about',
        path: '/about',
        to: '/about',
        label: { tw: '關於浩宇', en: 'about' },
        component: AboutPage,
        bannerImg: IMG.banner_about,
        navs: [
            {
                id: '1',
                label: '本所簡介',
                path: '/about',
            },
            {
                id: '1',
                label: '服務項目',
                path: '/business',
            },
            {
                id: '1',
                label: '專業團隊',
                path: '/team',
            },
            {
                id: '1',
                label: '法律期刊',
                path: '/periodical',
            },
            {
                id: '1',
                label: '最新消息',
                path: '/news',
            },
            {
                id: '1',
                label: '外部連結',
                path: '/external',
            },
            {
                id: '7',
                label: '停車資訊',
                path: '/parking',
            }
        ],
    }
]